import __vue_component__ from '../Button/Button.vue.js';
import ChevronLeftLargeIcon from '../Icon/ChevronLeftLargeIcon.js';
import ChevronRightLargeIcon from '../Icon/ChevronRightLargeIcon.js';
import addMonths from '../../node_modules/date-fns/esm/addMonths/index.js';
import addYears from '../../node_modules/date-fns/esm/addYears/index.js';
import subMonths from '../../node_modules/date-fns/esm/subMonths/index.js';
import subYears from '../../node_modules/date-fns/esm/subYears/index.js';

//
const DECADE = 10;
var script = {
  name: 'CalendarHeader',
  components: {
    ChevronLeftLargeIcon,
    ChevronRightLargeIcon,
    Button: __vue_component__
  },
  props: {
    month: {
      type: String,
      required: true
    },
    year: {
      type: Number,
      required: true
    },
    decade: {
      type: String,
      required: true
    },
    currentInterval: {
      type: String,
      default: 'days'
    }
  },

  data() {
    return {
      transition: 'slide-top'
    };
  },

  computed: {
    interval() {
      switch (this.currentInterval) {
        case 'days':
          return {
            header: `${this.month} ${this.year}`,
            next: t => addMonths(t, 1),
            prev: t => subMonths(t, 1)
          };

        case 'months':
          return {
            header: this.year,
            next: t => addYears(t, 1),
            prev: t => subYears(t, 1)
          };

        default:
          return {
            header: this.decade,
            next: t => addYears(t, DECADE),
            prev: t => subYears(t, DECADE)
          };
      }
    }

  },
  methods: {
    onNext() {
      this.transition = 'slide-right';
      this.$emit('prev', this.interval.next);
    },

    onPrev() {
      this.transition = 'slide-left';
      this.$emit('next', this.interval.prev);
    },

    changeInterval() {
      this.transition = 'slide-top';
      const interval = this.currentInterval === 'days' ? 'months' : 'years';
      this.$emit('change-interval', interval);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/CalendarHeader.vue_rollup-plugin-vue=script.js